/**
 * Workflow run names whose WebSocket lifecycle events drive reports-in-process list
 * removal or refetch. Sub-workflows (e.g. qa, post-processing) share report_uuid;
 * events for other names are ignored.
 */
export const WS_HANDLED_WORKFLOW_RUN_NAMES: string[] = [
  "amendment",
  "express-check",
  "express-check-sub-workflows",
  "instant-fit",
];

export function isHandledWorkflowRunName(
  name: string | null | undefined
): boolean {
  if (name == null || name === "") return false;
  return WS_HANDLED_WORKFLOW_RUN_NAMES.includes(name);
}
